import * as Types from "../actions/types";

const init = {
	data: {},
	pagination: {},
	error: {},
};

const subscriptionReducer = (state = init, action) => {
	switch (action.type) {
		case Types.SUBSCRIPTION_RETRIEVE: {
			return {
				...state,
				data: action.payload.response.data,
				pagination: action.payload.response.pagination,
			};
		}

		case Types.SUBSCRIPTION_SET: {
			if (Object.keys(state.data).length) {
				if (action.payload.fileInfo) {
					state.data.unshift(action.payload.fileInfo);
				}
			} else {
				state.data = action.payload.fileInfo;
			}

			return {
				...state,
			};
		}
		default:
			return state;
	}
};

export default subscriptionReducer;
